import React, { useState, useEffect } from 'react';
import {
  Box,
  Typography,
  TextField,
  IconButton,
  Paper,
  Avatar,
  Divider,
  Tooltip,
  Button,
  Input,
} from '@mui/material';
import {
  Send as SendIcon,
  Forum as ForumIcon,
  Comment as CommentIcon,
  UploadFile as UploadFileIcon,
} from '@mui/icons-material';
import Navbar from './Navbar';
import LeftNav from './LeftNav';
import AdvertCards from './AdvertCards';
import Breadcrumb from './BreadCrump';

export default function Community() {
  const [posts, setPosts] = useState([]);
  const [topic, setTopic] = useState('');
  const [caption, setCaption] = useState('');
  const [selectedFile, setSelectedFile] = useState(null);
  const [mediaType, setMediaType] = useState('');
  const [commentInputs, setCommentInputs] = useState({});

  const API_BASE = 'http://196.216.9.34:5020/api/community';
  const token = localStorage.getItem('token');

  const fetchPosts = async () => {
    try {
      const response = await fetch(`${API_BASE}/media-posts`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (!response.ok) throw new Error('Failed to fetch posts');
      const data = await response.json();
      setPosts(data);
    } catch (err) {
      console.error('Failed to fetch posts:', err);
    }
  };

  useEffect(() => {
    if (token) fetchPosts();
  }, [token]);

  const handlePost = async () => {
    if (!topic.trim()) return;

    try {
      const formData = new FormData();
      formData.append('topic', topic);
      formData.append('caption', caption);
      formData.append('media_type', mediaType);
      if (selectedFile) {
        formData.append('file', selectedFile);
      }

      const response = await fetch(`${API_BASE}/media-posts`, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${token}`,
        },
        body: formData,
      });

      if (!response.ok) throw new Error('Failed to create post');

      setTopic('');
      setCaption('');
      setSelectedFile(null);
      setMediaType('');
      fetchPosts();
    } catch (err) {
      console.error(err);
    }
  };

  const handleComment = async (postId) => {
    const comment = commentInputs[postId]?.trim();
    if (!comment) return;

    try {
      const response = await fetch(`${API_BASE}/posts/${postId}/comments`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ content: comment }),
      });
      if (!response.ok) throw new Error('Failed to add comment');
      setCommentInputs({ ...commentInputs, [postId]: '' });
      fetchPosts();
    } catch (err) {
      console.error(err);
    }
  };

  const determineMediaType = (file) => {
    if (!file) return '';
    const type = file.type;
    if (type.startsWith('image')) return 'image';
    if (type.startsWith('video')) return 'video';
    return 'document';
  };

  return (
    <>
      <Navbar />
      <LeftNav />
      <Box
        sx={{
          minHeight: '100vh',
          pt: '64px',
          pl: '240px',
          backgroundColor: '#f0f2f5',
          backgroundImage: 'url(/chatBackground.jpg)',
          backgroundAttachment: 'fixed',
        }}
      >
        <Box
          sx={{
            maxWidth: '90%',
            mx: 'auto',
            p: 2,
            background: 'linear-gradient(to bottom, rgba(255,255,255,0.9), rgba(255,255,255,0.95))',
          }}
        >
          <Breadcrumb currentPage="Community" />

          {/* Header */}
          <Box display="flex" alignItems="center" mb={2}>
            <ForumIcon sx={{ color: '#ff6600', fontSize: 32, mr: 1 }} />
            <Typography variant="h5" fontWeight="bold" color="#ff6600">
              Community Feed
            </Typography>
          </Box>

          {/* Post Input */}
          <Paper
            elevation={3}
            sx={{
              p: 2,
              mb: 4,
              borderRadius: 3,
              backgroundColor: '#ffffff',
            }}
          >
            <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
              Share something with the community
            </Typography>

            <TextField
              fullWidth
              variant="outlined"
              label="Topic"
              value={topic}
              onChange={(e) => setTopic(e.target.value)}
              sx={{ mb: 2, backgroundColor: '#f9f9f9', borderRadius: 2 }}
            />

            <TextField
              fullWidth
              variant="outlined"
              label="Caption"
              value={caption}
              onChange={(e) => setCaption(e.target.value)}
              sx={{ mb: 2, backgroundColor: '#f9f9f9', borderRadius: 2 }}
            />

            <Box display="flex" alignItems="center" gap={2} mb={2}>
              <Button
                variant="outlined"
                component="label"
                startIcon={<UploadFileIcon />}
              >
                Upload File
                <Input
                  type="file"
                  onChange={(e) => {
                    const file = e.target.files[0];
                    setSelectedFile(file);
                    setMediaType(determineMediaType(file));
                  }}
                  sx={{ display: 'none' }}
                />
              </Button>

              {selectedFile && (
                <Typography variant="body2" color="textSecondary">
                  {selectedFile.name}
                </Typography>
              )}

              <Tooltip title="Post">
                <IconButton
                  onClick={handlePost}
                  sx={{ bgcolor: '#ff6600', '&:hover': { bgcolor: 'black' } }}
                >
                  <SendIcon sx={{ color: '#fff' }} />
                </IconButton>
              </Tooltip>
            </Box>
          </Paper>

          {/* Ads */}
          <AdvertCards />

          {/* Posts */}
          {posts.map((post) => (
            <Paper
              key={post.id}
              elevation={2}
              sx={{
                p: 3,
                mb: 3,
                borderRadius: 4,
                backgroundColor: '#ffffff',
                
              }}
              
            >
              <Box display="flex" alignItems="center" mb={1} >
                <Avatar sx={{ bgcolor: '#ff6600', mr: 1 }}>
                  {post.sender[0]}
                </Avatar>
                <Typography fontWeight="bold">{post.sender}</Typography>
              </Box>

              <Typography variant="h6" fontWeight="500" gutterBottom>
                {post.topic}
              </Typography>

              {post.caption && (
                <Typography variant="body2" mb={1}>
                  {post.caption}
                </Typography>
              )}

              {post.media_url && post.media_type === 'image' && (
                <Box style={{ width: "200px", height: "200px", border: "1px solid #ff6600", borderRadius: "20px" }} >
                    <Box component="img" src={"http://196.216.9.34:5020"+post.media_url} alt="uploaded" sx={{ maxWidth: '100%'}} />
                </Box>
                
              )}

              {post.media_url && post.media_type === 'video' && (
                <Box style={{ width: "200px", border: "1px solid #ff6600", borderRadius: "20px" }} >
                  <video controls style={{ maxWidth: '100%', borderRadius: "20px"}}>
                    <source src={"http://196.216.9.34:5020"+post.media_url} />
                  </video>
                </Box>
              )}

              {post.media_url && post.media_type === 'document' && (
                <Box style={{ width: "200px", height: "200px", border: "1px solid #ff6600", borderRadius: "20px" }} >
                  <Button
                    href={"http://196.216.9.34:5020"+post.media_url}
                    target="_blank"
                    variant="outlined"
                    sx={{ textTransform: 'none' }}
                  >
                    View Document
                  </Button>
                </Box>
              )}

              <Divider sx={{ my: 2 }} />

              {/* Comments */}
              <Box ml={1}>
                {post.comments.map((comment, i) => (
                  <Box key={i} display="flex" alignItems="center" mb={1}>
                    <Avatar
                      sx={{
                        bgcolor: 'rgba(0,0,0,0.7)',
                        border: '3px solid #ff6600',
                        width: 28,
                        height: 28,
                        fontSize: 14,
                        mr: 1,
                      }}
                    >
                      {comment.sender[0]}
                    </Avatar>
                    <Typography variant="body2">
                      <strong>{comment.sender}:</strong> {comment.content}
                    </Typography>
                  </Box>
                ))}
              </Box>

              {/* Add Comment */}
              <Box display="flex" alignItems="center" mt={2}>
                <TextField
                  fullWidth
                  size="small"
                  placeholder="Add a comment..."
                  value={commentInputs[post.id] || ''}
                  onChange={(e) =>
                    setCommentInputs({
                      ...commentInputs,
                      [post.id]: e.target.value,
                    })
                  }
                  sx={{
                    backgroundColor: '#f9f9f9',
                    borderRadius: 2,
                  }}
                />
                <Tooltip title="Comment">
                  <IconButton
                    onClick={() => handleComment(post.id)}
                    sx={{
                      ml: 1,
                      bgcolor: '#ff6600',
                      '&:hover': { bgcolor: '#388e3c' },
                    }}
                  >
                    <CommentIcon sx={{ color: '#fff' }} />
                  </IconButton>
                </Tooltip>
              </Box>
            </Paper>
          ))}
        </Box>
      </Box>
    </>
  );
}
